import { keyBy } from 'lodash';
import FacebookSvg from '@src/svgs/social/facebook-blue.svg';
import InstagramSvg from '@src/svgs/social/instagram.svg';
import MeetfrankSvg from '@src/svgs/fr-frank-logo-black.svg';
import RepublishSvg from '@src/svgs/fr-double-arrow.svg';
import LikeSvg from '@src/svgs/fr-like.svg';
import ShareSvg from '@src/svgs/fr-share.svg';
import OpeningSvg from '@src/svgs/fr-opening.svg';
import PremiumPushSvg from '@src/svgs/fr-bell.svg';
import StarSvg from '@src/svgs/fr-star.svg';
import { OpeningPaidAddonEnum } from '@src/graphql/generated';
import { OpeningPaidAddonInterface } from './interfaces/openingPaidAddon.interface';

export const OPENING_PAID_ADDONS: OpeningPaidAddonInterface[] = [
  {
    icons: [LikeSvg],
    isActive: false,
    isBestSeller: false,
    isIncluded: true,
    isRecurring: false,
    label: 'virtual agency',
    priceInEur: 0,
    title: 'Virtual Agency',
    type: OpeningPaidAddonEnum.VIRTUAL_RECRUITER,
  },
  {
    icons: [ShareSvg],
    isActive: true,
    isBestSeller: false,
    isIncluded: true,
    isRecurring: false,
    label: 'public opening',
    priceInEur: 0,
    title: 'Public Opening',
    type: OpeningPaidAddonEnum.PUBLIC_OPENING,
  },
  {
    icons: [FacebookSvg, InstagramSvg],
    isActive: true,
    isBestSeller: true,
    isIncluded: false,
    isRecurring: false,
    label: 'social media',
    priceInEur: 149.0,
    title: 'Recruitment campaign on Social Media',
    type: OpeningPaidAddonEnum.SOCIAL_MEDIA_PREMIUM,
  },
  {
    icons: [RepublishSvg],
    isActive: false,
    isBestSeller: false,
    isIncluded: false,
    isRecurring: true,
    label: 'republishing',
    priceInEur: 59.0,
    title: 'Automated job offer republishing in every 2 weeks',
    type: OpeningPaidAddonEnum.AUTOMATED_REPUBLISH,
  },
  {
    icons: [MeetfrankSvg],
    isActive: false,
    isBestSeller: false,
    isIncluded: false,
    isRecurring: true,
    label: 'best of meetFrank',
    priceInEur: 319.0,
    title: 'Best of MeetFrank package',
    type: OpeningPaidAddonEnum.BEST_OF_MEETFRANK,
  },
  {
    icons: [OpeningSvg],
    isActive: false,
    isBestSeller: false,
    isIncluded: false,
    isRecurring: false,
    label: 'interview',
    priceInEur: 499.0,
    title: 'Inspiring interview on MeetFrank Blog',
    type: OpeningPaidAddonEnum.BLOG_INTERVIEW,
  },
  {
    icons: [StarSvg],
    isActive: false,
    isBestSeller: true,
    isIncluded: false,
    isRecurring: true,
    label: 'featured',
    priceInEur: 299.0,
    title: 'Featured opening',
    type: OpeningPaidAddonEnum.FEATURED_OPENING,
  },
  {
    icons: [PremiumPushSvg],
    isActive: false,
    isBestSeller: false,
    isIncluded: false,
    isRecurring: false,
    label: 'premium push',
    priceInEur: 249.0,
    title: 'Premium push',
    type: OpeningPaidAddonEnum.PREMIUM_PUSH,
  },
  {
    icons: [FacebookSvg],
    isActive: false,
    isBestSeller: false,
    isIncluded: false,
    isRecurring: false,
    label: 'social media basic',
    priceInEur: 99.0,
    title: 'Social media Basic package',
    type: OpeningPaidAddonEnum.SOCIAL_MEDIA_BASIC,
  },
  {
    icons: [],
    isActive: false,
    isBestSeller: false,
    isIncluded: false,
    isRecurring: false,
    label: 'basic branding',
    priceInEur: 0,
    title: 'Basic Branding',
    type: OpeningPaidAddonEnum.BRANDING_BASIC,
  },
  {
    icons: [],
    isActive: false,
    isBestSeller: false,
    isIncluded: false,
    isRecurring: false,
    label: 'premium branding',
    priceInEur: 129.0,
    title: 'Premium Branding',
    type: OpeningPaidAddonEnum.BRANDING_PREMIUM,
  },
];

export const OPENING_PAID_ADDONS_BY_TYPE: Partial<Record<OpeningPaidAddonEnum, OpeningPaidAddonInterface>> = keyBy(
  OPENING_PAID_ADDONS,
  'type',
);
